//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StockOverviewWidget from "../Widgets/StockOverviewWidget.vue";
import PurchaseSuggestionWidget from "../Widgets/PurchaseSuggestionWidget.vue";
import OrdersToPickWidget from "../Widgets/OrdersToPickWidget.vue";
import ExpectedDeliveryWidget from "../Widgets/ExpectedDeliveryWidget.vue";
import InventoryTurnoverRateWidget from "../Widgets/InventoryTurnoverRateWidget.vue";
import PurchaseOverviewWidget from "../Widgets/PurchaseOverviewWidget.vue";
import SerialNumberSearchWidget from "../Widgets/SerialNumberSearchWidget.vue";
import DeliveryPressisionWidget from "../Widgets/DeliveryPressisionWidget.vue";
import Top10ProductSales from "../Widgets/Top10ProductSales.vue";
import DayStatisticsWidget from "../Widgets/DayStatisticsWidget.vue";
import PurchaseValueWidget from "../Widgets/PurchaseValueWidget.vue";

import Muuri from "muuri";

export default {
  components: {
    StockOverviewWidget,
    PurchaseSuggestionWidget,
    OrdersToPickWidget,
    ExpectedDeliveryWidget,
    InventoryTurnoverRateWidget,
    PurchaseOverviewWidget,
    SerialNumberSearchWidget,
    DeliveryPressisionWidget,
    Top10ProductSales,
    DayStatisticsWidget,
    PurchaseValueWidget,
  },

  data() {
    return {
      grid: null,
      isDraggable: false,
      lockGridText: "Lås opp grid",
      defaultVisibleWidgets: ["1", "2", "3", "4", "5", "6", "7", "8","9", "10"],
      visibleWidgets: [],
      visibleWidgetsOptions: [
        { id: "1", name: "Ordre som bør plukkes" },
        { id: "2", name: "Forventede leveranser" },
        { id: "3", name: "Lageroversikt" },
        { id: "4", name: "Innkjøpsforslag" },
        { id: "5", name: "Varelagerets omløpshastighet" },
        { id: "6", name: "Bestillingshjelp" },
        { id: "7", name: "Søk i serienummer" },
        { id: "8", name: "Top 10 mest solgte varer" },
    { id: "9", name: "Dagstatistikk" },    
    { id: "10", name: "Leveranse Presisjon" },
    { id: "11", name: "Innkjøps verdi" },
        
      ],
    };
  },

  async mounted() {    
    await this.initVisibleColumns();
    await this.initGrid();
    this.onVisibleWidgetChange();
  },

  methods: {
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });
      await this.$router.go(0);
      setTimeout(() => {
        notif();
      }, 1000);
    },
 
    async initGrid() {
      var ref = this;
      this.grid = new Muuri(".grid", {
        dragEnabled: true,
        dragStartPredicate: function(item, e) {
          // Start moving the item after the item has been dragged for one second.
          if (e.deltaTime > 500) {
            return true;
          }
        },
        layoutOnInit: false,
      }).on("move", function() {
        ref.saveLayout();
      });

      var layout = window.localStorage.getItem("layout");
      if (layout) {
        this.loadLayout(this.grid, layout);
      } else {
        this.grid.layout(true);
      }
    },

    serializeLayout(grid) {
      var itemIds = grid.getItems().map(function(item) {
        return item.getElement().getAttribute("data-id");
      });
      return JSON.stringify(itemIds);
    },

    async saveLayout() {
      var layout = this.serializeLayout(this.grid);
      window.localStorage.setItem("layout", layout);
    },

    loadLayout(grid, serializedLayout) {
      var layout = JSON.parse(serializedLayout);

      // Add and show new widgets
      if (layout.length != this.visibleWidgetsOptions.length) {
        this.visibleWidgetsOptions.forEach((x) => {
          if (!layout.includes(x.id)) {
            layout.push(x.id);
            if (!this.visibleWidgets.includes(x.id)) {
              this.visibleWidgets.push(x.id);
            }
          }
        });
        this.saveLayout();
        this.onVisibleWidgetChange();
      }

      var currentItems = grid.getItems();
      var currentItemIds = currentItems.map(function(item) {
        return item.getElement().getAttribute("data-id");
      });
      var newItems = [];

      for (var i = 0; i < layout.length; i++) {
        var itemId = layout[i];
        var itemIndex = currentItemIds.indexOf(itemId);
        if (itemIndex > -1) {
          newItems.push(currentItems[itemIndex]);
        }
      }

      grid.sort(newItems, { layout: "instant" });
    },

    onVisibleWidgetChange() {
      this.grid.getItems().forEach((item) => {
        var id = item.getElement().getAttribute("data-id");
        if (this.visibleWidgets.includes(id)) {
          this.grid.show([item]);
        } else {
          this.grid.hide([item]);
        }
      });

      this.$cookies.set("widgetColumns", this.visibleWidgets.join(","), "1Y");
    },

    initVisibleColumns() {
      var cookieColums = this.$cookies.get("widgetColumns");
      if (!cookieColums) {
        this.visibleWidgets = this.defaultVisibleWidgets;
      }

      if (cookieColums) {
        var columns = [];
        cookieColums.split(",").forEach(function(col) {
          columns.push(col);
        });

        this.visibleWidgets = columns;
      }
    },
  },
};
